import { cloneDeep } from "lodash";

import { ApiHotelItem } from "@/api/hotel";

export const SORT_OPTIONS = [
  {
    value: 0,
    label: `Lowest Point Price`,
    fn: (a: ApiHotelItem, b: ApiHotelItem) => {
      if (a.book_info?.points_rate < b.book_info?.points_rate) {
        return -1;
      }
      return 1;
    },
    condition: (type: "booking" | "all") => type === "booking",
  },
  {
    value: 1,
    label: `Popularity`,
    fn: (a: ApiHotelItem, b: ApiHotelItem) => {
      if (a.popularity > b.popularity) {
        return -1;
      }
      return 1;
    },
  },
  {
    value: 2,
    label: `Rating High to Low`,
    fn: (a: ApiHotelItem, b: ApiHotelItem) => {
      if (a.g_rating > b.g_rating) {
        return -1;
      }
      return 1;
    },
  },
  // {
  //   value: 2,
  //   label: `Max Point Value`,
  //   fn: (a: ApiHotelItem, b: ApiHotelItem) => {
  //     if ((a.point_val_max || a.max_val) > (b.point_val_max || b.max_val)) {
  //       return -1;
  //     }
  //     return 1;
  //   },
  // },
  {
    value: 3,
    label: `Median Point Value`,
    fn: (a: ApiHotelItem, b: ApiHotelItem) => {
      if ((a.point_val_median || a.mid_val) > (b.point_val_median || b.mid_val)) {
        return -1;
      }
      return 1;
    },
  },
  // {
  //   value: 4,
  //   label: `Median Point Price`,
  //   fn: (a: ApiHotelItem, b: ApiHotelItem) => {
  //     if (a.points_median == 0 || a.points_median == null || a.points_median == undefined) {
  //       return 1
  //     } else if (b.points_median == 0 || b.points_median == null || b.points_median == undefined) {
  //       return -1
  //     }
  //     console.log(a.points_median, b.points_median)
  //     if ((a.points_median) < (b.points_median)) {
  //       return -1;
  //     }
  //     return 1;
  //   },
  // },
  {
    value: 4,
    label: `Availability High to Low`,
    fn: (a: ApiHotelItem, b: ApiHotelItem) => {
      if (a.availability > b.availability) {
        return -1;
      }
      return 1;
    },
  },
];

/**
 * 排序
 */
export const sortFn = (list: ApiHotelItem[], sortKey?: number): ApiHotelItem[] => {
  const targetSort = SORT_OPTIONS.find((item) => item.value === sortKey);
  return targetSort?.fn ? cloneDeep(list).sort(targetSort?.fn) : list;
};
